/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_FreezesInputs */

const en_recipe_freezes = /** @type {(inputs: Recipe_FreezesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freezes well`)
};

const de_recipe_freezes = /** @type {(inputs: Recipe_FreezesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lässt sich einfrieren`)
};

/**
* | output |
* | --- |
* | "Freezes well" |
*
* @param {Recipe_FreezesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_freezes = /** @type {((inputs?: Recipe_FreezesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_FreezesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_freezes(inputs)
	return en_recipe_freezes(inputs)
});